import { render, staticRenderFns } from "./deal-reward-rate-import.vue?vue&type=template&id=4b5b7d10&scoped=true"
import script from "./deal-reward-rate-import.vue?vue&type=script&lang=js"
export * from "./deal-reward-rate-import.vue?vue&type=script&lang=js"
import style0 from "./deal-reward-rate-import.vue?vue&type=style&index=0&id=4b5b7d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b7d10",
  null
  
)

export default component.exports